import React from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableFooter from '@material-ui/core/TableFooter';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import Done from '@material-ui/icons/Done';
import DeleteIcon from '@material-ui/icons/Delete';
import _ from 'lodash';
import { Link } from "react-router-dom";
import {connect} from "react-redux";
import {ACTION_TYPES, actions} from "../../actions";
import Typography from "@material-ui/core/Typography";

import AssessmentsFilter from './AssessmentsFilter'
import AssessmentsSearchBar from "./AssessmentsSearchBar";

const actionsStyles = theme => ({
    root: {
        flexShrink: 0,
        color: theme.palette.text.secondary,
        marginLeft: theme.spacing.unit * 2.5,
    },
});

class TablePaginationActions extends React.Component {

    handleBackButtonClick = event => {
        this.props.onChangePage(event, this.props.page - 1);
    };

    handleNextButtonClick = event => {
        this.props.onChangePage(event, this.props.page + 1);
    };


    render() {
        const {classes, count, page, rowsPerPage, theme} = this.props;

        return (
            <div className={classes.root}>

                <IconButton
                    onClick={this.handleBackButtonClick}
                    disabled={page === 0}
                    aria-label="Previous Page"
                >
                    {theme.direction === 'rtl' ? <KeyboardArrowRight/> : <KeyboardArrowLeft/>}
                </IconButton>
                <IconButton
                    onClick={this.handleNextButtonClick}
                    disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                    aria-label="Next Page"
                >
                    {theme.direction === 'rtl' ? <KeyboardArrowLeft/> : <KeyboardArrowRight/>}
                </IconButton>

            </div>
        );
    }
}

TablePaginationActions.propTypes = {
    classes: PropTypes.object.isRequired,
    count: PropTypes.number.isRequired,
    onChangePage: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
    theme: PropTypes.object.isRequired,
};

const TablePaginationActionsWrapped = withStyles(actionsStyles, {withTheme: true})(
    TablePaginationActions,
);

const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
    },
    table: {
        minWidth: 500,
    },
    tableWrapper: {
        overflowX: 'auto',
    },
    button: {
        margin: theme.spacing.unit,
    }
});

class AssessmentsTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            page: 0,
            rowsPerPage: 10,
            assessments:[],
        };
    };

    async getUserAssessments(){
        if(!this.props.form.adminView){
            const query = {unid: this.props.user.unid, page: this.props.form.page+1||1, limit: this.props.form.limit||10};
            await this.props.fetchAssessments(query);
        }
    }

    handleChangePage = async (event, page) => {
        await this.props.setNewFields({
            type:ACTION_TYPES.SET_FIELDS.SET_FILTER_INPUTS,
            payload:{...this.props.form,page:page}
        }).then(await this.getUserAssessments())
    };

    shouldComponentUpdate(nextProps, nextState) {
        return this.props.assessments !== nextProps.assessments || this.props.form.page;
    }

    handleChangeRowsPerPage = async (event) => {
        await this.props.setNewFields({
            type:ACTION_TYPES.SET_FIELDS.SET_FILTER_INPUTS,
            payload:{...this.props.form,page:0,limit:event.target.value}
        }).then(await this.getUserAssessments())
    };

    async componentDidMount() {
        if(!this.props.form.page||!this.props.form.limit){
            this.props.setNewFields({
                type:ACTION_TYPES.SET_FIELDS.SET_FILTER_INPUTS,
                payload:{...this.props.form,...{page:0},...{limit:10}}
            }).then(this.getUserAssessments());
        }
    }

    handleRemove = (val) => (event) => {
        this.props.removeAssessment(val).then(() => {
            this.forceUpdate();
        });
    };

    renderTerms(terms) {
        let stringTerms =  _.map(terms, option => {
            return option.name;
        });
        let str = stringTerms.toString();
        return str.replace(/,/g, ', ');
    }

    renderRows(list) {
        if(list.docs) {
            return _.map(list.docs, row => {
                let reviewed = '';
                if(row.reviewers.reduce((allFinished, reviewer) => allFinished && reviewer.finished, true)) {
                    reviewed = <Done/>
                }
                return (
                    <TableRow key={row._id} style={{height:70}}>
                        <TableCell component="th" scope="row">
                            <Link style={{color: '#000', textDecoration: 'underline',fontWeight: '700'}} to={`/assessment/${row._id}`}>
                                {row.name}
                            </Link>
                        </TableCell>
                        <TableCell>{row.program.name}</TableCell>
                        <TableCell>{row.department.name}</TableCell>
                        <TableCell>{this.renderTerms(row.terms)}</TableCell>
                        <TableCell>{reviewed}</TableCell>
                        {/*<TableCell><IconButton  aria-label="Delete" onClick={this.handleRemove(row._id)}>*/}
                        {/*    <DeleteIcon style={{cursor: 'pointer'}}/>*/}
                        {/*</IconButton></TableCell>*/}
                    </TableRow>
                );
            })
        }
    }

    render() {
        const { classes } = this.props;
        return (
            <Paper className={classes.root}>
                {this.props.form.adminView?<div style={{marginRight:'10px'}}><AssessmentsFilter/><AssessmentsSearchBar/></div>:null
                }
                <div className={classes.tableWrapper}>
                    <Table className={classes.table}>
                        <TableHead>
                            <TableRow>
                                <TableCell>Assessment</TableCell>
                                <TableCell>Program</TableCell>
                                <TableCell>Department</TableCell>
                                <TableCell>Semester</TableCell>
                                <TableCell>Completed</TableCell>
                                {/*<TableCell>Delete Assessment</TableCell>*/}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {this.renderRows(this.props.assessments)}
                        </TableBody>
                        <TableFooter>
                            <TableRow>
                                <TablePagination
                                    colSpan={5}
                                    count={this.props.assessments.total || 0}
                                    rowsPerPage={this.props.assessments.limit || 0}
                                    page={this.props.form.page}
                                    onChangePage={this.handleChangePage}
                                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                    ActionsComponent={TablePaginationActionsWrapped}
                                />
                            </TableRow>
                        </TableFooter>
                    </Table>
                </div>
            </Paper>
        );
    }
}


function mapStateToProps(state) {
    return {form:state.filteredAssessmentsForm, user: state.user, assessments: state.assessments};
}

export default connect(mapStateToProps, actions)(withStyles(styles)(AssessmentsTable));


